import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import tailwind from "./tailwind.css?url";
import App from "./App.tsx";
import { BrowserRouter } from "react-router";
import { ErrorBoundary } from "react-error-boundary";
import "dayjs/locale/fr";
import "dayjs/locale/en";
import "dayjs/locale/de";
import dayjs from "dayjs";
import { i18n, loadCatalog, getInitialLocale } from "./i18n";
import { LocaleProvider } from "./contexts/LocaleContext";

const storedLocale = getInitialLocale();
await loadCatalog(storedLocale);
dayjs.locale(storedLocale);
// window.onNotificationReceived = (notificationStringified: string) => {
//   const notification: Notification = JSON.parse(notificationStringified);
//   const url = notification.request.content.data.url;
//   alert(`setting navigateToUrl from notification: ${url}`);
//   window.localStorage.setItem("navigateToUrl", url);
// };

// window.onNotificationResponseReceived = (responseStringified: string) => {
//   const response: NotificationResponse = JSON.parse(responseStringified);
//   const url = response.notification.request.content.data.url;
//   alert(`setting navigateToUrl from notification response: ${url}`);
//   window.localStorage.setItem("navigateToUrl", url);
// };

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <link rel="shortcut icon" href="/favicon.svg" type="image/x-icon" />
    <link rel="stylesheet" href={tailwind} />

    <BrowserRouter>
      <ErrorBoundary
        // FallbackComponent={UnexpectedError}
        fallbackRender={() => <div>Error</div>}
        onReset={(_details) => {
          // Reset the state of your app so the error doesn't happen again
        }}
      >
        <LocaleProvider initialLocale={storedLocale} i18n={i18n}>
          <App />
        </LocaleProvider>
      </ErrorBoundary>
    </BrowserRouter>
  </StrictMode>,
);
